import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import MyAppCard from './MyAppCard';
import EmptyFavoritesTab from './EmptyFavoritesTab';
import { MISC } from '../lib/constants';

/**
 * render all the categories for desktop or laptop screensize.
 * @param {*} props
 */
const DefaultCategoriesListCards = props => {
  const { tools, toggleFavorite, setApp, setTool, category, user } = props;

  const categoryName = get(category, 'name', ''),
    categoryItems = get(category, 'items', []),
    /*  We need to re-render the favorites tab when unfavoriting, otherwise a bug 
        occurs where the status of the heart icon is reversed for the tool after the one that is unfavorited
        also shows as unfavorited in the UI
    */
    [renderKey, updateRenderKey] = useState(0);

  useEffect(() => {
    if (categoryName === MISC.FAVORITES) {
      updateRenderKey(renderKey + 1);
    }
  }, [tools]);

  const renderApps = () => {
    if (categoryName === MISC.FAVORITES && categoryItems.length === 0) {
      return <EmptyFavoritesTab {...props} />;
    }

    return categoryItems.map((item, index) => (
      <MyAppCard
        app={item}
        user={user}
        key={index}
        tools={tools}
        setApp={setApp}
        setTool={setTool}
        toggleFavorite={toggleFavorite}
      />
    ));
  };

  return (
    <div id="tools-cards" key={`${categoryName}-${renderKey}-tabview`}>
      {renderApps()}
    </div>
  );
};

DefaultCategoriesListCards.propTypes = {
  user: PropTypes.object,
  toggleFavorite: PropTypes.func,
  setApp: PropTypes.func,
  setTool: PropTypes.func,
  tools: PropTypes.object,
  category: PropTypes.object
};

export default DefaultCategoriesListCards;
